import { createAction, props } from "@ngrx/store";
import { User } from "../../models/user.model";
import { Doubt, Comment } from "../../models/doubt.model";

export const LOAD_DOUBTS = '[Doubts] Load doubts';
export const LOAD_DOUBTS_SUCCESS = '[Doubts] Load doubts success';
export const LOAD_DOUBTS_FAIL = '[Doubts] Load doubts fail';
export const ADD_COMMENT = '[Doubts] Add comment';
export const ADD_COMMENT_SUCCESS = '[Doubts] Add comment success';
export const ADD_COMMENT_FAIL = '[Doubts] Add comment fail';
export const ADD_DOUBT = '[Doubts] Add doubt';
export const ADD_DOUBT_SUCCESS = '[Doubts] Add doubt success';
export const ADD_DOUBT_FAIL = '[Doubts] Add doubt fail';
export const SELECT_DOUBT = '[Doubts] Select Doubt';
export const UNSELECT_DOUBT = '[Doubts] Unselect Doubt';

export const LoadDoubtsAction = createAction(
    LOAD_DOUBTS,
    props<{ user: User }>()
);

export const LoadDoubtsSuccessAction = createAction(
    LOAD_DOUBTS_SUCCESS,
    props<{ data: Doubt[] }>()
);

export const LoadDoubtsFailAction = createAction(
    LOAD_DOUBTS_FAIL,
    props<{ error: Error }>()
);

export const AddCommentAction = createAction(
    ADD_COMMENT,
    props<{ comment: Comment; doubt: Doubt }>()
);

export const AddCommentSuccessAction = createAction(
    ADD_COMMENT_SUCCESS,
    props<{ comment: Comment; doubt: Doubt }>()
);

export const AddCommentFailAction = createAction(
    ADD_COMMENT_FAIL,
    props<{ error: Error }>()
);

export const AddDoubtAction = createAction(
    ADD_DOUBT,
    props<{ doubt: Doubt; user: User }>()
);

export const AddDoubtSuccessAction = createAction(
    ADD_DOUBT_SUCCESS,
    props<{ data: Doubt }>()
);

export const AddDoubtFailAction = createAction(
    ADD_DOUBT_FAIL,
    props<{ error: Error }>()
);

export const SelectDoubtAction = createAction(
    SELECT_DOUBT,
    props<{ doubtId: string }>()
  );
  
export const UnselectDoubtAction = createAction(UNSELECT_DOUBT);
